// SPDX-License-Identifier: AGPL-3.0-or-later
import {SERVER_BADGE_ASSETS} from '@app/features/guild/utils/ServerBadgeAssets';
import {remFromPx} from '@app/features/theme/layout/RemFromPx';
import Theme from '@app/features/theme/state/Theme';
import {observer} from 'mobx-react-lite';
interface DiscoverableBadgeIconProps { size?: number; className?: string; tone?: 'dark' | 'light'; }
export const DiscoverableBadgeIcon = observer(({size = 16, className, tone}: DiscoverableBadgeIconProps) => {
  const light = tone === 'light' || (tone == null && Theme.effectiveTheme === 'light');
  return <img src={SERVER_BADGE_ASSETS[light ? 'discoverable-light' : 'discoverable-dark']} alt="" aria-hidden="true" draggable={false} style={{width:remFromPx(size),height:remFromPx(size)}} className={className} data-flx="ui.icons.discoverable-badge-icon.img" />;
});
